import create from './create'
import export_ from './export'

export default {
  loading: 'Loading chats...',
  empty: 'No chats',

  type: {
    image: 'Image',
    document: 'Document',
    video: 'Video',
  },

  select_assigned: {
    title: 'Filter',
    all: 'All chats',
    assigned_me: 'Assigned to me',
    favorite: 'Favorites',
    resolved: 'Resolved chats',
  },
  select_status: {
    title: 'Status',
    all: 'All',
    0: 'New',
    1: 'Chat',
    2: 'Resolved',
  },

  create,
  export: export_,
}
